// extracted by mini-css-extract-plugin
export default {"p_tye":"_6d9cdba7ba","slcted":"be0ab4bd11","slc_color":"a98959b3ba","item_p":"af3f15092b","r0":"_2af7693345"};